import { useMutation } from "@tanstack/react-query";
import type { InferRequestType } from "hono";
import { client } from "@/api/client";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";

// Inferred from the route so the scoped `role` enum stays in lock-step (UNB-1912).
type SendInvitePayload = InferRequestType<typeof client.admin.invitation.$post>["json"];
export const useSendInvite = () => {
  return useMutation({
    mutationFn: async (payload: SendInvitePayload) => {
      const res = await client.admin.invitation.$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin", "invitation"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "users"] });
      const touchedMerchantIds = new Set<string>(Object.values(variables.workspaceBrands ?? {}).flat());
      for (const merchantId of touchedMerchantIds) {
        queryClient.invalidateQueries({ queryKey: ["admin", "merchant", merchantId] });
      }
    },
  });
};
